import { Component, Inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogTitle,
	MatDialogContent,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';

export interface DialogData {
	title: string;
	message: string;
}

@Component({
	selector: 'app-dialog',
	templateUrl: './app-dialog.component.html',
	styleUrls: ['./app-dialog.component.css'],
	imports: [MatDialogTitle, CdkScrollable, MatDialogContent],
})
export class AppDialogComponent {
	constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
